import { TranslationService } from '@/app/services/translation.service';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EResult } from '../../models';

interface Team {
  name: string;
  logo: string;
  score: number;
  penaltyScore: number | null;
}

export interface IPastMatch {
  home: Team;
  away: Team;
  result: string;
  matchDate: string;
  id: string;
  tsExternalId: string;
  competition: {
    name: string;
    logo: string;
  };
}

@Component({
  selector: 'app-past-match-item',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterLink],
  templateUrl: './past-match-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PastMatchItemComponent {
  private translationService = inject(TranslationService);
  private translateService = inject(TranslateService);

  match = input.required<IPastMatch>();

  letterWin = ['W', 'G'];
  letterLose = ['L', 'P'];
  letterDraw = ['D', 'E'];

  result = computed(() => {
    switch (this.match().result) {
      case EResult.WIN:
        return this.translateService.instant('W');
      case EResult.LOSE:
        return this.translateService.instant('L');
      case EResult.DRAW:
        return this.translateService.instant('D');

      default:
        return this.match().result;
    }
  });

  getUrlForMatch() {
    const initPath = this.translationService.getInitPathFootballMath();
    const home = this.translationService.normalizeRoute(this.match().home.name);
    const away = this.translationService.normalizeRoute(this.match().away.name);
    const slug = `${home}-vs-${away}`;

    // return ['/' + initPath, slug, this.match().id];

    return `/${initPath}/${slug}/${this.match().id}`;
  }
}
